import React from 'react';
import { cn } from '../../lib/utils';

const WellnessScore = ({ score, size = 'md', showLabel = true }) => {
  const sizes = {
    sm: { wrapper: 'w-12 h-12', text: 'text-sm', stroke: 3 },
    md: { wrapper: 'w-20 h-20', text: 'text-xl', stroke: 4 },
    lg: { wrapper: 'w-28 h-28', text: 'text-2xl', stroke: 5 },
    xl: { wrapper: 'w-36 h-36', text: 'text-3xl', stroke: 6 },
  };

  const { wrapper, text, stroke } = sizes[size];
  
  const getColor = (score) => {
    if (score >= 75) return '#27AE60'; // Green - Excellent
    if (score >= 50) return '#F39C12'; // Yellow - Watch
    if (score >= 25) return '#E67E22'; // Orange - Concern
    return '#C0392B'; // Red - Urgent
  };

  const getLabel = (score) => {
    if (score >= 75) return 'Excellent';
    if (score >= 50) return 'Watch';
    if (score >= 25) return 'Concern';
    return 'Urgent';
  };

  const color = getColor(score);
  const label = getLabel(score);
  
  // Calculate SVG parameters
  const radius = 45;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (score / 100) * circumference;

  return (
    <div className="flex flex-col items-center gap-1" data-testid="wellness-score">
      <div className={cn("relative", wrapper)}>
        <svg className="w-full h-full circular-progress" viewBox="0 0 100 100">
          {/* Background circle */}
          <circle
            cx="50"
            cy="50"
            r={radius}
            fill="none"
            stroke="#E5E0FF"
            strokeWidth={stroke}
          />
          {/* Progress circle */}
          <circle
            cx="50"
            cy="50"
            r={radius}
            fill="none"
            stroke={color}
            strokeWidth={stroke}
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            style={{ transition: 'stroke-dashoffset 0.5s ease-in-out' }}
          />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <span className={cn("font-heading font-bold", text)} style={{ color }}>
            {score}
          </span>
        </div>
      </div>
      {showLabel && (
        <span 
          className="text-xs font-medium uppercase tracking-wider"
          style={{ color }}
        >
          {label}
        </span>
      )}
    </div>
  );
};

export default WellnessScore;
